export function isNativeConsentPassed(_window) {
    const searchParams = new URLSearchParams(_window.location?.search);
    const hasConsentParam = searchParams.has('_sp_pass_consent');

    try {
        if (hasConsentParam) {
            _window.sessionStorage.setItem('_sp_pass_consent', 'true');
            return true;
        }

        const storedConsent = _window.sessionStorage.getItem('_sp_pass_consent');
        if (storedConsent === 'true') {
            searchParams.set('_sp_pass_consent', 'true');
            const newUrl = `${_window.location.pathname}?${searchParams.toString()}${_window.location.hash}`;
            _window.history.replaceState({}, '', newUrl);
            return true;
        }
    } catch (e) {
        return hasConsentParam;
    }

    return false;
}


const mobileWebViewUa = ['_app_', 'tv.nu', 'FinnApp', 'Omni'];
export function isWebView(_navigator) {
    // Check for Hermes (case-insensitive) in user agent
    // Based on app team's detection: https://app-foundation-docs.pages.schibsted.ghe.com/user-agents.html
    const isHermesApp = /hermes/i.test(_navigator.userAgent);

    // Check for other known app identifiers
    const hasOtherAppIdentifier = mobileWebViewUa.some((webviewAgent) => _navigator.userAgent.includes(webviewAgent));

    return isHermesApp || hasOtherAppIdentifier;
};

export function checkIfShouldDisableOnWebview(window, navigator, config) {
    return isWebView(navigator) && !config.disableNativeConsentCheck && !isNativeConsentPassed(window)
};
